// W12 step A5 (2026-10-09): the names every account-scoped thing in quil is built from, in one
// dependency-free place so `auth.ts`, the store binding and the sync coordination can all read them
// without importing each other. Quil's own file (not canonical).
//
// Quil keeps almost nothing about an account in localStorage: the library, the sync queue, the
// delta token, the trash, the snapshots and the conflicts are all in the Dexie store, so they scope
// with it. What is left in localStorage is device-level and stays unscoped, as it was:
//
//   device   `quil.hasSignedInBefore`, `quil.signedOut`, `quil.autoLoginAttempted`: how THIS device
//            signs in, not what an account holds
//            the canonical error-log and expectation keys: diagnostics of this build on this device
//            `quil.firstBoot`, `quil.lastAccount`, `quil.newerDataSeen`: this device's own W12 bookkeeping
//   scoped   `quil.store@<id>`: the marker "this account has its own scoped store" (new)
import { accountOfStoreName, scopedKey } from './storageScope'

/** The pre-W12 database name, and the base every account's scoped name is built on. */
export const BASE = 'QuilDatabase'

/** Where P2's evidence is recorded (`firstBoot.ts`): `msalReady` records it, `login` ends it. */
export const FIRST_BOOT_KEY = 'quil.firstBoot'
/** The last account whose store this device opened: a device pointer, never a proof of ownership. */
export const LAST_ACCOUNT_KEY = 'quil.lastAccount'
/** Which build last met local data from a newer one (`readOnly.ts`). */
export const NEWER_DATA_KEY = 'quil.newerDataSeen'

/** The marker written only AFTER a scoped store has opened and been stamped (never from an error path). */
export function markerKey(accountId: string): string {
  return scopedKey('quil.store', accountId)
}

/** The account a store name belongs to: the scoped suffix, or null for the bare (legacy) name. */
export function accountOfStore(storeName: string): string | null {
  return accountOfStoreName(BASE, storeName)
}
